import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import '../../../index.scss';
import { customBaseUrl, httpPost } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';
import { Modal } from 'antd';

const EditTypeModal = ({ showModal, hideModal, className, getReferralTypes, typeData }) => {
  const [data, setData] = useState({});

  const handleUpdateType = async () => {
    showLoader();
    let res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/referral_type/update_referral_type`, data);

    hideLoader();
    if (res.status) {
      hideModal(false);
      getReferralTypes();
      Swal.fire('Success', res.message, 'success');
    } else {
      Swal.fire('Failed', res.message, 'error');
    }
  };

  useEffect(() => {
    if (typeData) {
      setData(typeData);
    }
  }, [typeData]);

  return (
    <Modal
      className={className}
      centered
      visible={showModal}
      onCancel={() => hideModal(false)}
      width={400}
      footer={null}
    >
      <div className='col-md-12 mt-4' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
        <label className='form-label'>Select Business Type</label>
        <select
          className='form-select border'
          value={data?.accountTypeEnum || ""}
          required
          onChange={(e) => setData({ ...data, accountTypeEnum: e.target.value })}
        >
          <option value="" disabled>--Select account type</option>
          <option value="PERSONAL">Personal</option>
          <option value="CORPORATE">Corporate</option>
        </select>
      </div>

      <div className='col-md-12 mt-4' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
        <label className='form-label'>Is Default</label>
        <select
          className='form-select border'
          value={data?.defaultType === true ? 'true' : 'false'}
          required
          onChange={(e) => setData({ ...data, defaultType: e.target.value === 'true' })}
        >
          <option value="" disabled>--Select</option>
          <option value='true'>TRUE</option>
          <option value='false'>FALSE</option>
        </select>
      </div>

      <div className='col-md-12 mt-4' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
        <label className='form-label'>Transaction Count Required?</label>
        <select
          className='form-select border'
          value={data?.numberOfTransactionRequired === true ? 'true' : 'false'}
          required
          onChange={(e) => {
            const isRequired = e.target.value === 'true';
            setData({
              ...data,
              numberOfTransactionRequired: isRequired,
              numberCount: isRequired ? data.numberCount : 0
            });
          }}
        >
          <option value="" disabled>--Select</option>
          <option value='true'>TRUE</option>
          <option value='false'>FALSE</option>
        </select>
      </div>

      <div className='col-md-12 mt-4' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
        <label className='form-label'>Number of Transfer Count</label>
        <input
          type='number'
          className='form-control'
          disabled={!data?.numberOfTransactionRequired}
          value={data?.numberCount || 0}
          onChange={(e) => setData({ ...data, numberCount: parseInt(e.target.value, 10) || 0 })}
        />
      </div>

      <div className='col-md-12 mt-4' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
        <label className='form-label'>Referral Description</label>
        <input
          type='text'
          className='form-control'
          value={data?.referralDescription || ""}
          required
          onChange={(e) => setData({ ...data, referralDescription: e.target.value })}
        />
      </div>

      <div className='col-12 text-end mt-5'>
        <button className='btn btn-primary' type='button' onClick={handleUpdateType}>
          Update
        </button>
      </div>
    </Modal>
  );
};

export default EditTypeModal;
